var UrlBuilder = /** @class */ (function () {
    function UrlBuilder(rawUrl) {
        var _this = this;
        this.pathSegments = [];
        this.pathVariable = new Map();
        var _a = rawUrl.split('?'), path = _a[0], searchQuery = _a[1];
        path.split('/').forEach(function (pathSegment) {
            _this.pathSegments.push(pathSegment);
        });
        this.urlParams = new URLSearchParams(searchQuery);
    }
    UrlBuilder.prototype.setPathVariable = function (name, value) {
        this.pathVariable.set(":".concat(name), value);
        return this;
    };
    UrlBuilder.prototype.setSearchParam = function (name, value) {
        this.urlParams.set(name, value);
        return this;
    };
    UrlBuilder.prototype.toString = function () {
        var _this = this;
        var path = this.pathSegments
            .map(function (pathSegment) {
            if (pathSegment.startsWith(':')) {
                return _this.pathVariable.get(pathSegment);
            }
            return pathSegment;
        })
            .join('/');
        return "".concat(path).concat(this.urlParams.toString() ? '?' : '').concat(this.urlParams);
    };
    return UrlBuilder;
}());
export { UrlBuilder };
//# sourceMappingURL=url-builder.js.map